import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webimports-dev/htdocs/web-imports/src/app/portfolio/PortfolioPage.tsx");
